export { MdbIconComponent } from './icon.component';
export { MdbIconModule } from './icon.module';
